import React, { useEffect, useState, useRef } from "react";
import "./dashboard.scss";
import DataTable from "./DataTable/DataTable";
import axios from "axios";
import { Api_Url } from "../../../utils/ApiUrl";
import Modal from "react-bootstrap/Modal";
// import axios from 'axios';
// import { Api_Url } from '../../../utils/ApiUrl';
import { useHistory } from "react-router-dom";
import { chartData } from "../../../redux/action";
import { useDispatch } from "react-redux";

import Web3 from "web3";
import { toast } from "react-toastify";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import { useDetectClickOutside } from "react-detect-click-outside";
import { CopyToClipboard } from "react-copy-to-clipboard";
import CurrentRound from "../../../hooks/dataFetchers/round";
import tableup from "../../../assets/tableup.svg";
import tabledown from "../../../assets/tabledown.svg";
import { useSelector } from "react-redux";

import moment from "moment";
import Countrychart from "./CountryChart";
import useAdminAllowed from "../../../hooks/userManagement/useAdminAllowed";

const Dashboard = ({
  user,
  setUser,
  tomiPrice,
  usdPrice,
  btcPrice,
  pepePrice,
  linkPrice,
  uniPrice,
  dopPrice,
  gemsPrice,
  hitfunctionss,
}) => {
  let userRole = user?.role;
  const goldenUserData = useSelector((state) => state?.user?.users);
  // // console.log(
  //   goldenUserData,
  //   "   gemsLockedGolden  gemsLockedGolden gemsLockedGolden gemsLockedGolden gemsLockedGolden"
  // );

  const [project, setProject] = useState("NFA");
  const dispatch = useDispatch();

  const projectPercentage = {
    DOP: 0.05,
    GEMS: 0.05,
    LEIA: 0.05,
    OLYMPUS: 0.05,
    INCENTIV: 0.05,
    NFA: 0.1,
  };
  const checkAdminPermission = useAdminAllowed();
  const [topTenApiCalled, setTopTenApiCalled] = useState(false);
  const [transactionApiCalled, setTransactionApiCalled] = useState(false);
  const { currentRound } = CurrentRound();
  const [totalRound, setTotalRound] = useState([]);

  const tok = localStorage?.getItem("accessToken");
  const [welcome, setwelcome] = useState();
  // const [usdPrice, setUsdPrice] = useState(0);
  // // console.log("sdfdsfsdf", usdPrice)
  // const [tomiPrice, setchange24hr1] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [specialAccess, setSpecialAccess] = useState([]);
  const [myTree, setMyTree] = useState([]);

  const [otherLeadersPurchasedAmount, setOtherLeadersPurchasedAmount] =
    useState([]);
  const [selectedRounds, setSelectedRounds] = useState([]);

  const [userselectdate, setuserselectdate] = useState(false);
  const [pc, setPC] = useState(0);
  const [pmc, setPMC] = useState(0);
  const [nrc, setNRC] = useState(0);
  const [lc, setLC] = useState(0);
  const [dpc, setDPC] = useState(0);
  const [lec, setLEC] = useState(0);
  const [a, seta] = useState(0);
  const [m, setm] = useState(0);
  const [s, sets] = useState(0);
  const [g, setg] = useState(0);
  const [gmini, setgmini] = useState(0);

  const [totalleader, settotalleader] = useState(0);
  const [activeleader, setactiveleader] = useState(0);
  const [round, setRound] = useState([]);

  // const [dopPrice, setDopPrice] = useState(0);
  const [search, setSearch] = useState("");
  const [topLeaderSearch, setTopLeaderSearch] = useState("");

  const [dataTime, setDataTime] = useState("1");
  const [dataTimeTop, setDataTimeTop] = useState("1");
  const [showtext, SetShowtext] = useState(false);

  const [orderField, setOrderField] = useState("transactionTime");
  const [orderDirection, setOrderDirection] = useState("-1");
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState([]);
  const [topTenLeaders, setTopTenLeaders] = useState([]);
  const [topThreeData, setTopThreeData] = useState([]);

  // const [tomiPrice, setTomiPrice] = useState("");
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);

  const [showcalendar, setShowCalendar] = useState(false);

  const history = useHistory();

  const [loader, setLoader] = useState(false);
  const [alllset, setalllset] = useState("1");
  const [name, setName] = useState("");
  const [role, setRole] = useState(null);
  const [addr, setAddr] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => {
    setName("");
    setAddr("");
    setEmail("");
    // setRole(null);
    setShow1(false);
  };
  const [refLists, setRefLists] = useState([]);

  const [selectedItem, setSelectedItem] = useState(null);
  const [activeTab, setActiveTab] = useState("home-tab");

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
    setRole(null);
  };
  const handleItemClick = (imgSrc, text, creatorWalletAddress, rounds) => {
    setSelectedItem({ imgSrc, text, creatorWalletAddress, rounds });
    setProject(text);
  };
  const toggleRoundSelection = (round) => {
    setSelectedRounds((prevRounds) =>
      prevRounds.includes(round)
        ? prevRounds.filter((r) => r !== round)
        : [...prevRounds, round]
    );
  };
  function isValidEmail(email) {
    var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(email);
  }

  function isAddressValid(address) {
    return Web3.utils.isAddress(address);
  }

  useEffect(() => {
    if (activeTab == "profile-tab") {
      GetTopTenLeaders();
    }
  }, [
    activeTab,
    topLeaderSearch,
    dataTime,
    dataTimeTop,
    round,
    userRole,
    project,
  ]);

  ///////////////////////////////////////////////////////////////////////////////////
  const GetTopTenLeaders = async () => {
    // if (account) {
    let time;
    if (dataTime && user?.role == "admin") {
      time = dataTime;
    } else if (dataTimeTop && user?.role != "admin") {
      time = dataTimeTop;
    }
    let date = null;
    let date1 = null;
    if (time == "1") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      //////////////////////////////////////////
      // var date12 = new Date();

      // var dateOffset = 24 * 60 * 60 * 1000; // 24 hours (1 day) in milliseconds
      // var myDate = new Date(date12.getTime() - dateOffset); // Subtract 24 hours from the current time

      // date = myDate.toISOString(); // Start time (24 hours ago)
      // date1 = date12.toISOString(); // Current time as end time
    } else if (time == "seven") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "year") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (time == "month") {
      var date12 = new Date();
      // var datesnd = (date12.getDate() - 7)
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      // // console.log(“dsdssdfsdfsdf”,myDate,date12)
      //     let a = new Date(datesnd)
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }

    let url = `${Api_Url}/referral/admin/referrals?limit=10`;

    if (url != null) {
      let dynamicQuery = url;

      url = dynamicQuery;
      var config = {
        // get api so don't need to add useAdminAllowed();
        method: "post",
        url: url,
        data: {
          limit: 10,
          offset: 1,

          orderField: "totalSaleConverted",
          orderDirection: -1,
        },
        headers: {
          authorization: `Bearer ` + tok,
        },
      };

      axios(config)
        .then(function (response) {
          setTopTenLeaders(response?.data?.data?.allReferrals);
          setTopTenApiCalled(true);
        })
        .catch(function (error) {
          setTopTenApiCalled(true);

          // console.log(error);
        });
    }
    // }
  };

  const GetTopTenLeaders1 = async (times) => {
    // if (account) {
    setalllset();
    setuserselectdate(true);
    setState(times);
    let date = null;
    let date1 = null;
    if (times) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(b).utc().format("Y-MM-DDT23:59:59");
    }

    if (date && date1) {
      let url = null;

      url = `${Api_Url}/users/top-leaders?limit=10&privateSale=${project}`;

      if (url != null) {
        let dynamicQuery = url;

        if (topLeaderSearch) {
          dynamicQuery += `&search=${topLeaderSearch}`;
        }
        dynamicQuery += `&startDate=${date}&endDate=${date1}`;

        if (round) {
          dynamicQuery += `&round=${round}`;
        }

        url = dynamicQuery;
        var config = {
          method: "get",
          url: url,
          headers: {
            authorization: `Bearer ` + tok,
          },
        };

        axios(config)
          .then(function (response) {
            setTopTenLeaders(response?.data?.data);
            setTopTenApiCalled(true);
          })
          .catch(function (error) {
            setTopTenApiCalled(true);

            // console.log(error);
          });
      }
    }
    // }
  };

  const AddAgent =async () => {
    // await checkAdminPermission();
    const lowerCaseEmail = email.toLowerCase();
    const val = localStorage.getItem("accessToken");
    let url = null;
    if (user?.role === "admin") {
      url = `${Api_Url}/users/god-agents`;
    } else if (role === "mega_agent") {
      url = `${Api_Url}/users/mega-agents`;
    } else if (role === "super_agent") {
      url = `${Api_Url}/users/super-agents`;
    } else if (role === "agent") {
      url = `${Api_Url}/users/agents`;
    } else if (role === "mini_agent") {
      url = `${Api_Url}/users/mini-agents`;
    }
    if (name?.length > 2) {
      if (isAddressValid(addr)) {
        if (isValidEmail(email)) {
          setLoader(true);
          var config = {
            method: "post",
            url: url,
            data: {
              name: name,
              walletAddress: addr,
              email: lowerCaseEmail,
              name: name,
            },
            headers: {
              Authorization: "Bearer " + val,
            },
          };
          axios(config)
            .then(function (response) {
              setLoader(false);

              setName("");
              setAddr("");
              setEmail("");
              // setRole(null);
              handleClose1();
              setShow2(true);
            })
            .catch(function (error) {
              setLoader(false);
              setRole(null);

              toast.error(error?.response?.data?.message);
              if (error?.response?.status == 401) {
                // localStorage.removeItem("accessToken");
                // history.push("/");
              }
            });
        } else {
          setError("Incorrect Email!");
        }
      } else {
        setError("Incorrect wallet address!");
      }
    } else {
      setError("Name must be of length 3!");
    }
  };

  function convertToTitleCase(input) {
    if (input) {
      let words = input
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      if (words[0] === "mini" || words[0] === "Mini") {
        return "Ambassador";
      }
      if (
        words[words.length - 1].toLowerCase() === "agent" &&
        (words[0] != "mini" || words[0] != "Mini")
      ) {
        words[words.length - 1] = "Leader";
      }
      if (words[0] === "super" || words[0] === "Super") {
        return "Super";
      } else if (words[0] !== "agent") {
        return words.join(" ");
      } else {
        return "Leader";
      }
    } else {
      return "";
    }
  }

  const handlePageChange = (e) => {
    const selectedPage = e.selected;

    setPage(selectedPage);
  };

  const getTransactionsData = () => {
    // console.log("traansaction called");
    setLoader(true);

    var config = {
      method: "post",
      // get api so don't need to add useAdminAllowed();
      url: `${Api_Url}/referral/admin/transactions`,
      data: {
        limit: 10,
        offset: page + 1,
        privateSaleFilter: [{ privateSale: selectedItem?.text, round: round }],
        orderField: orderField,
        orderDirection: orderDirection,
      },
      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    axios(config)
      .then(function (res) {
        // console.log("trx data: ", res?.data?.data?.alltransactions);
        setTransactions(res?.data?.data?.alltransactions);
        setPageCount(res?.data?.data?.pages);
        // setTransactionApiCalled(false);
        setLoader(false);

        // setLoader(false);
      })
      .catch(function (error) {
        // setTransactionApiCalled(true);

        setLoader(false);
      });
  };

  const [adminobj, setadminobj] = useState();

  const getProjectsList = async () => {
    // const tok = localStorage?.getItem("accessToken");
    var config = {
      method: "get",
      url: `${Api_Url}/projects/private-sale?isPremiumProject=false`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        if (response?.data?.data?.projects?.length > 0) {
          let dummy = response?.data?.data?.projects[0];
          let dummy2 = {
            imgSrc: "",
            text: "",
          };
          dummy2.imgSrc = dummy.projectImg;
          dummy2.text = dummy.tokenSymbol;
          dummy2.creatorWalletAddress = dummy.creatorWalletAddress;
          dummy2.rounds = dummy.totalRounds;
          for (let i = 0; i < dummy2.rounds; i++) {
            round.push(i + 1);
          }
          // console.log("roundns: ", round, dummy2.rounds);

          setSelectedItem(dummy2);
        }
        setRefLists(response?.data?.data?.projects);
      })
      .catch(function (error) {
        // console.log("/projects/private-sale?isPremiumProject=false", error);
      });
  };

  useEffect(() => {
    if (tok && round?.length > 0) {
      getTransactionsData();
    }
  }, [
    usdPrice,
    user,
    search,
    orderField,
    orderDirection,
    round?.length,
    project,
  ]);

  useEffect(() => {
    if (usdPrice) {
      if (user?.role == "admin") {
        setwelcome("Admin");
        // GetDashboardData1();
        // GetChartsData();
      }
    }
  }, [user]);

  // Admin data upper stats

  const GetDashboardData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/referral/admin/stats?privateSale=${selectedItem?.text}`,
      // url: `${Api_Url}/users/leader-counts?startDate=${stDate}&&endDate=${enDate}`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    let dynamicQuery = config.url;

    if (startDate && startDate != null) {
      dynamicQuery += `&startDate=${startDate}&endDate=${endDate}`;
    }
    if (startDate && startDate != null && selectedRounds?.length > 0) {
      dynamicQuery += `&round=[${[selectedRounds]}]`;
    } else if (selectedRounds?.length > 0) {
      dynamicQuery += `?round=[${selectedRounds}]`;
    }

    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        // setChartsData(resData);
        if (response?.data?.data?.data?.stats?.length > 0) {
          setadminobj(response?.data?.data?.data?.stats[0]);
        } else {
          setadminobj();
        }
        let value = response?.data?.data;
        // console.log("value: ", value);
        setStatsData(value);
        // if (times) {
        let purchaseChange =
          ((value?.stats[0]?.count - value?.oldStats[0]?.count) /
            value?.oldStats[0]?.count) *
          100;
        setPC(purchaseChange);

        let newPurchasedAmount =
          value?.stats[0]?.totalPurchaseEth * usdPrice +
          value?.stats[0]?.totalPurchaseUsdt;
        let oldPurchasedAmount =
          value?.oldleadersStats[0]?.totalPurchaseEth * usdPrice +
          value?.oldleadersStats[0]?.totalPurchaseUsdt;

        let purchasedAmountChange = 0;

        if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
          purchasedAmountChange = 0;
        } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
          if (newPurchasedAmount === 0) {
            purchasedAmountChange =
              ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
          }
          if (oldPurchasedAmount === 0) {
            purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
          }
        } else {
          purchasedAmountChange =
            ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
            100;
        }

        setPMC(purchasedAmountChange);

        setNRC(value?.netRevenueChange);

        let newLeadersCount =
          value?.agents +
          value?.godAgents +
          value?.megaAgents +
          value?.superAgents +
          value?.miniAgents;
        let oldLeadersCount =
          value?.oldleaders +
          value?.oldgodLeaders +
          value?.oldmegaLeaders +
          value?.oldsuperLeaders +
          value?.oldminiLeaders;
        let leadersChange = 0;
        if (newLeadersCount === 0 && oldLeadersCount === 0) {
          leadersChange = 0;
        } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
          if (newLeadersCount === 0) {
            leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
          }
          if (oldLeadersCount === 0) {
            leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
          }
        } else {
          leadersChange =
            ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
        }
        setLC(leadersChange);
        let dopChange =
          ((value?.stats[0]?.totalDopPurchased -
            value?.oldleadersStats[0]?.totalDopPurchased) /
            value?.oldleadersStats[0]?.totalDopPurchased) *
          100;
        setDPC(dopChange);

        let totalLeaderEarningsEthValueOld =
          value?.oldleadersStats[0]?.totalLeaderEarningsEth * usdPrice;

        let totalLeaderEarningsEthValueNew =
          value?.stats[0]?.totalLeaderEarningsEth * usdPrice;

        let totalLeaderEarningsOldPrice =
          totalLeaderEarningsEthValueOld +
          value?.oldleadersStats[0]?.totalLeaderEarningsUsdt;
        let totalLeaderEarningsNewPrice =
          totalLeaderEarningsEthValueNew +
          value?.stats[0]?.totalLeaderEarningsUsdt;

        let totalLeadersEarningChange = 0;

        if (
          totalLeaderEarningsNewPrice === 0 &&
          totalLeaderEarningsOldPrice === 0
        ) {
          totalLeadersEarningChange = 0;
        } else if (
          totalLeaderEarningsNewPrice === 0 ||
          totalLeaderEarningsOldPrice === 0
        ) {
          if (totalLeaderEarningsNewPrice === 0) {
            totalLeadersEarningChange =
              ((0 - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }
          if (totalLeaderEarningsOldPrice === 0) {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
          }
        } else {
          totalLeadersEarningChange =
            ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
              totalLeaderEarningsOldPrice) *
            100;
        }

        setLEC(totalLeadersEarningChange);
        // } else {
        setPC("");
        setPMC("");

        setNRC("");
        setLC("");
        setDPC("");
        setLEC("");
        // }

        seta(value?.agents);
        setg(value?.godAgents);
        setm(value?.megaAgents);
        sets(value?.superAgents);
        setgmini(value?.miniAgents);

        settotalleader(
          value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents
        );
        setactiveleader(value?.activeLeaders);
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  const firstTimeData = async () => {
    try {
      let b = await currentRound(project);

      if (b) {
        const result = [];
        for (let i = 1; i <= b; i++) {
          result.push(i);
        }
        setTotalRound(result);
      }
    } catch (err) {
      // console.log(err.message);
    }
  };

  // const closeDropdown = () => {
  //   // // console.log("ddddddd")
  //   setShowCalendar(!showcalendar);
  // };
  // const ref = useDetectClickOutside({ onTriggered: closeDropdown });
  // // console.log("ddddddd", showcalendar);

  const [copy, setCopy] = useState(false);
  const textCopiedFun2 = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 1000);
  };

  const [hoveredElements, setHoveredElements] = useState({
    icon1: false,
    icon2: false,
    icon3: false,
    icon4: false,
    icon5: false,
    icon6: false,
  });
  const handleMouseEnter = (element) => {
    setHoveredElements({ ...hoveredElements, [element]: true });
    const isMobileView = window.innerWidth < 768;
    if (isMobileView) {
      setTimeout(() => {
        setHoveredElements({ ...hoveredElements, [element]: false });
      }, 5000);
    }
  };
  const handleMouseLeave = (element) => {
    setHoveredElements({ ...hoveredElements, [element]: false });
  };

  const [profitChange, setProfitChange] = useState("0");
  const [buybackChange, setBuybackChange] = useState("0");

  const [tokenInsuredChange, setTokenInsuredChange] = useState("0");
  const [insuredCountChange, setInsuredCountChange] = useState("0");
  const [statsData, setStatsData] = useState({});

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    localStorage.setItem("project", project);

    firstTimeData();
  }, [project]);

  useEffect(() => {
    formatDates("1");
    getProjectsList();
  }, []);

  useEffect(() => {
    if (tok && tok !== null) {
      GetTopTenLeaders();
    }
  }, [startDate, endDate, round, project, selectedRounds?.length, activeTab]);

  useEffect(() => {
    if (tok && selectedItem) {
      GetDashboardData();
    }
  }, [
    selectedItem,
    startDate,
    endDate,
    round,
    project,
    selectedRounds?.length,
  ]);

  const formatDates = (times) => {
    let date = null;
    let date1 = null;
    if (Array.isArray(times)) {
      let a = new Date(times[0]?.startDate);
      let b = new Date(times[0]?.endDate);
      date = moment(a).format("Y-MM-DDT00:00:00");
      date1 = moment(b).format("Y-MM-DDT23:59:59");
    } else if (times == "1") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "seven") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "year") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (times == "month") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }
    setStartDate(date);
    setEndDate(date1);
  };

  return (
    <>
      <section className="dashboard">
        <div className="custom-container">
          {user?.role == "admin" ? (
            <h3 className="welcomesss">Hi {welcome ? welcome : ""}</h3>
          ) : (
            ""
          )}

          <div className="mainbuttonsss">
            <div className="main-heading m-0">
              <div>
                {/* <p className="selfhead">Premium Projects</p> */}
                <p className="selfhead">self serve Projects</p>
                <h6>Dashboard</h6>
              </div>
            </div>
            <button className="gusvtsvtvtsvxs" onClick={() => setShow1(true)}>
              Add Leader
            </button>
            {user?.role == "admin" ? (
              <div className="parent-twice-custom">
                <div className="dropdown">
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {selectedItem && (
                      <div className="projectmain">
                        <img
                          src={selectedItem?.imgSrc}
                          alt="projectimg"
                          className="projectimg"
                          width={24}
                        />

                        <p className="projectpara">{selectedItem?.text}</p>
                      </div>
                    )}
                    <img
                      src="/assets/arrow-down.svg"
                      alt="arrow-down"
                      className="img-fluid"
                    />
                  </button>
                  <ul className="dropdown-menu">
                    {refLists?.map((item, index) => {
                      return (
                        <li key={index}>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={() =>
                              handleItemClick(
                                item?.projectImg,
                                item?.tokenSymbol,
                                item?.creatorWalletAddress,
                                item?.totalRounds
                              )
                            }
                          >
                            <div className="projectmain">
                              <img
                                src={item?.projectImg}
                                alt="projectimg"
                                className="projectimg"
                                width={24}
                              />
                              <p className="projectpara">{item?.tokenSymbol}</p>
                            </div>
                          </a>
                        </li>
                      );
                    })}

                    {/* <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() =>
                          handleItemClick("/assets/nfa.svg", "NFA")
                        }
                      >
                        <div className="projectmain">
                          <img
                            src="/assets/nfa.svg"
                            alt="projectimg"
                            className="projectimg"
                            width={24}
                          />
                          <p className="projectpara">NFA</p>
                        </div>
                      </a>
                    </li> */}
                  </ul>
                </div>
                {selectedItem && (
                  <div class="dropdown">
                    <button
                      class="btn btn-secondary dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Rounds
                      <img
                        src="\assets\arrow-down.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a
                          class="dropdown-item"
                          href="#"
                          onClick={() => {
                            setSelectedRounds([]);
                          }}
                        >
                          All Rounds
                        </a>
                      </li>
                      {Array.from(
                        { length: selectedItem.rounds },
                        (_, index) => {
                          const roundNumber = index + 1;
                          const isSelected =
                            selectedRounds.includes(roundNumber);

                          return (
                            <li key={roundNumber} className="roundmain">
                              <label className="cyberpunk-checkbox-label">
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={() =>
                                    toggleRoundSelection(roundNumber)
                                  }
                                  className="cyberpunk-checkbox"
                                />
                              </label>
                              <p className="roundnumber">Round {roundNumber}</p>
                            </li>
                          );
                        }
                      )}
                    </ul>
                  </div>
                )}

                <div className="custom-tab-bar">
                  <a
                    onClick={() => {
                      setalllset("1");
                      setDataTime("1");
                      formatDates("1");
                    }}
                    className={alllset == "1" ? "active" : "noactive"}
                  >
                    1D
                  </a>
                  <a
                    onClick={() => {
                      setalllset("seven");
                      setDataTime("seven");
                      formatDates("seven");
                    }}
                    className={alllset == "seven" ? "active" : "noactive"}
                  >
                    7D
                  </a>
                  <a
                    onClick={() => {
                      setalllset("month");
                      setDataTime("month");
                      formatDates("month");
                    }}
                    className={alllset == "month" ? "active" : "noactive"}
                  >
                    1M
                  </a>
                  <a
                    onClick={() => {
                      setalllset("year");
                      setDataTime("year");
                      formatDates("year");
                    }}
                    className={alllset == "year" ? "active" : "noactive"}
                  >
                    1Y
                  </a>
                  <a
                    onClick={() => {
                      setalllset("all");
                      setDataTime("");
                      formatDates("");
                    }}
                    className={alllset == "all" ? "active" : "noactive"}
                  >
                    All
                  </a>
                  <a onClick={() => setShowCalendar(!showcalendar)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M17.0831 3.56V2C17.0831 1.59 16.7431 1.25 16.3331 1.25C15.9231 1.25 15.5831 1.59 15.5831 2V3.5H9.08312V2C9.08312 1.59 8.74311 1.25 8.33312 1.25C7.92312 1.25 7.58312 1.59 7.58312 2V3.56C4.88312 3.81 3.57311 5.42 3.37311 7.81C3.35311 8.1 3.59311 8.34 3.87311 8.34H20.7931C21.0831 8.34 21.3231 8.09 21.2931 7.81C21.0931 5.42 19.7831 3.81 17.0831 3.56Z"
                        fill="#8C8C8C"
                      />
                      <path
                        d="M20.3331 9.83984H4.33313C3.78313 9.83984 3.33313 10.2898 3.33313 10.8398V16.9998C3.33313 19.9998 4.83313 21.9998 8.33313 21.9998H16.3331C19.8331 21.9998 21.3331 19.9998 21.3331 16.9998V10.8398C21.3331 10.2898 20.8831 9.83984 20.3331 9.83984ZM9.54313 18.2098C9.49313 18.2498 9.44313 18.2998 9.39313 18.3298C9.33313 18.3698 9.27313 18.3998 9.21313 18.4198C9.15313 18.4498 9.09313 18.4698 9.03313 18.4798C8.96313 18.4898 8.90313 18.4998 8.83313 18.4998C8.70313 18.4998 8.57313 18.4698 8.45313 18.4198C8.32313 18.3698 8.22313 18.2998 8.12313 18.2098C7.94313 18.0198 7.83313 17.7598 7.83313 17.4998C7.83313 17.2398 7.94313 16.9798 8.12313 16.7898C8.22313 16.6998 8.32313 16.6298 8.45313 16.5798C8.63313 16.4998 8.83313 16.4798 9.03313 16.5198C9.09313 16.5298 9.15313 16.5498 9.21313 16.5798C9.27313 16.5998 9.33313 16.6298 9.39313 16.6698C9.44313 16.7098 9.49313 16.7498 9.54313 16.7898C9.72313 16.9798 9.83313 17.2398 9.83313 17.4998C9.83313 17.7598 9.72313 18.0198 9.54313 18.2098ZM9.54313 14.7098C9.35313 14.8898 9.09313 14.9998 8.83313 14.9998C8.57313 14.9998 8.31313 14.8898 8.12313 14.7098C7.94313 14.5198 7.83313 14.2598 7.83313 13.9998C7.83313 13.7398 7.94313 13.4798 8.12313 13.2898C8.40313 13.0098 8.84313 12.9198 9.21313 13.0798C9.34313 13.1298 9.45313 13.1998 9.54313 13.2898C9.72313 13.4798 9.83313 13.7398 9.83313 13.9998C9.83313 14.2598 9.72313 14.5198 9.54313 14.7098ZM13.0431 18.2098C12.8531 18.3898 12.5931 18.4998 12.3331 18.4998C12.0731 18.4998 11.8131 18.3898 11.6231 18.2098C11.4431 18.0198 11.3331 17.7598 11.3331 17.4998C11.3331 17.2398 11.4431 16.9798 11.6231 16.7898C11.9931 16.4198 12.6731 16.4198 13.0431 16.7898C13.2231 16.9798 13.3331 17.2398 13.3331 17.4998C13.3331 17.7598 13.2231 18.0198 13.0431 18.2098ZM13.0431 14.7098C12.9931 14.7498 12.9431 14.7898 12.8931 14.8298C12.8331 14.8698 12.7731 14.8998 12.7131 14.9198C12.6531 14.9498 12.5931 14.9698 12.5331 14.9798C12.4631 14.9898 12.4031 14.9998 12.3331 14.9998C12.0731 14.9998 11.8131 14.8898 11.6231 14.7098C11.4431 14.5198 11.3331 14.2598 11.3331 13.9998C11.3331 13.7398 11.4431 13.4798 11.6231 13.2898C11.7131 13.1998 11.8231 13.1298 11.9531 13.0798C12.3231 12.9198 12.7631 13.0098 13.0431 13.2898C13.2231 13.4798 13.3331 13.7398 13.3331 13.9998C13.3331 14.2598 13.2231 14.5198 13.0431 14.7098ZM16.5431 18.2098C16.3531 18.3898 16.0931 18.4998 15.8331 18.4998C15.5731 18.4998 15.3131 18.3898 15.1231 18.2098C14.9431 18.0198 14.8331 17.7598 14.8331 17.4998C14.8331 17.2398 14.9431 16.9798 15.1231 16.7898C15.4931 16.4198 16.1731 16.4198 16.5431 16.7898C16.7231 16.9798 16.8331 17.2398 16.8331 17.4998C16.8331 17.7598 16.7231 18.0198 16.5431 18.2098ZM16.5431 14.7098C16.4931 14.7498 16.4431 14.7898 16.3931 14.8298C16.3331 14.8698 16.2731 14.8998 16.2131 14.9198C16.1531 14.9498 16.0931 14.9698 16.0331 14.9798C15.9631 14.9898 15.8931 14.9998 15.8331 14.9998C15.5731 14.9998 15.3131 14.8898 15.1231 14.7098C14.9431 14.5198 14.8331 14.2598 14.8331 13.9998C14.8331 13.7398 14.9431 13.4798 15.1231 13.2898C15.2231 13.1998 15.3231 13.1298 15.4531 13.0798C15.6331 12.9998 15.8331 12.9798 16.0331 13.0198C16.0931 13.0298 16.1531 13.0498 16.2131 13.0798C16.2731 13.0998 16.3331 13.1298 16.3931 13.1698C16.4431 13.2098 16.4931 13.2498 16.5431 13.2898C16.7231 13.4798 16.8331 13.7398 16.8331 13.9998C16.8331 14.2598 16.7231 14.5198 16.5431 14.7098Z"
                        fill="#8C8C8C"
                      />
                    </svg>
                  </a>
                  {/* {showcalendar && ( */}
                  {showcalendar && (
                    <div className="cal set-custom-calendar-div">
                      <DateRange
                        editableDateInputs={true}
                        onChange={(item) => {
                          formatDates([item.selection]);
                          if (activeTab == "profile-tab") {
                            GetTopTenLeaders1([item.selection]);
                          }
                        }}
                        moveRangeOnFirstSelection={false}
                        ranges={state}
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : null}
          </div>

          <div className="bottom-cards">
            <div className="single-card">
              <div className="twice-set-items">
                <img
                  src="\assets\dashboard\noofpurchases.svg"
                  alt="img"
                  className="img-fluid"
                />
                <div className="inner-text">
                  <p>No. of Purchases</p>
                  <h6>
                    {statsData?.stats?.length > 0
                      ? statsData?.stats[0]?.count || 0
                      : 0}{" "}
                    <span className={pc > 0 ? "green-text" : "red-text"}>
                      {pc ? pc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                </div>
              </div>
              <div className="bottom-text">
                {/* <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? tokenNftStats?.tokensPurchasesCount?.toFixed(4)
                      : 0}{" "}
                    Token
                  </p> */}
                {/* <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? parseInt(
                          tokenNftStats?.nftPurchasesCount?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    NFT
                  </p> */}
              </div>
            </div>
            <div className="single-card" style={{ overflow: "hidden" }}>
              <div className="twice-set-items">
                <img
                  src="/assets/incentive-purchased.svg"
                  alt="img"
                  className="img-fluid"
                />
                <div className="inner-text">
                  <p>{selectedItem && selectedItem?.text} Purchased</p>
                  <h6>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                          (statsData?.stats?.length > 0
                            ? statsData.stats[0]?.dopPurchased
                            : 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}
                    &nbsp;
                    {selectedItem && selectedItem?.text}
                    <span className={dpc > 0 ? "green-text" : "red-text"}>
                      {dpc ? dpc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                </div>
              </div>

              <div className="bottom-text">
                {/* <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseFloat(
                        statsData?.stats[0]?.dopPurchased?.toFixed(4)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  Token
                </p> */}
                {/* <p className="uni-text">
                  <span></span>
                  {tokenNftStats?.nftStats?.length > 0
                    ? parseInt(
                        tokenNftStats?.nftStats[0]?.totalDopPurchased?.toFixed(
                          2
                        )
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  NFT
                </p> */}
              </div>
              {/* <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>~
                    {dops ? ((dops?.eth + dops?.us) * dopPrice)?.toFixed(2) : 0}{" "}
                    USD
                  </p>
                </div> */}
            </div>
            <div className="single-card">
              <div className="twice-set-items">
                <img
                  src="\assets\dashboard\purchasedamount.svg"
                  alt="img"
                  className="img-fluid"
                />
                <div className="inner-text">
                  <p>Purchased Amount</p>

                  <h6 className="datahead">
                    {statsData?.stats?.length > 0
                      ? "~$" +
                        parseInt(
                          statsData?.stats[0]?.totalSaleConverted ||
                            0
                              // usdPrice *
                              //   (tokenNftStats?.purchasedAmount[0]
                              //     ?.totalPurchaseEth || 0) +
                              // btcPrice *
                              //   (tokenNftStats?.purchasedAmount[0]
                              //     ?.totalPurchaseWbtc || 0) +
                              // (tokenNftStats?.purchasedAmount[0]
                              //   ?.totalPurchaseUsdt || 0) +
                              // dopPrice *
                              //   (tokenNftStats?.purchasedAmount[0]
                              //     ?.totalPurchaseDopToken || 0) +
                              // (tokenNftStats?.purchasedAmount[0]
                              //   ?.totalPurchaseUsdc || 0) +
                              // pepePrice *
                              //   (tokenNftStats?.purchasedAmount[0]
                              //     ?.totalPurchasePepe || 0) +
                              // linkPrice *
                              //   (tokenNftStats?.purchasedAmount[0]
                              //     ?.totalPurchaseLink || 0) +
                              // uniPrice *
                              //   (tokenNftStats?.purchasedAmount[0]
                              //     ?.totalPurchaseUni || 0)
                              ?.toFixed(2)
                        ).toLocaleString("en-US")
                      : 0}{" "}
                    <span className={pmc > 0 ? "green-text" : "red-text"}>
                      {pmc ? pmc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                </div>
              </div>
              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseFloat(statsData?.stats[0]?.totalEth || 0)?.toFixed(4)
                    : 0}{" "}
                  ETH
                </p>
                <p className="uni-text">
                  <span></span>
                  {statsData?.stats?.length > 0
                    ? parseInt(
                        parseFloat(
                          statsData?.stats[0]?.totalUsdt || 0
                        )?.toFixed(2)
                      )?.toLocaleString("en-US")
                    : 0}{" "}
                  USDT
                </p>
              </div>
              <div class="dropdown cardinsidedrop">
                <button
                  class=""
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="7"
                    viewBox="0 0 13 7"
                    fill="none"
                  >
                    <path
                      d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                      fill="#fff"
                    />
                    <path
                      d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                      fill="#fff"
                    />
                  </svg>
                </button>
                <ul class="dropdown-menu newmenu">
                  <div className="text">
                    <p>ETH</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(statsData?.stats[0]?.totalEth || 0)?.toFixed(
                          4
                        )
                      : 0}{" "}
                    ETH
                  </div>
                  <div className="text">
                    <p>USDT</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                          parseFloat(
                            statsData?.stats[0]?.totalUsdt || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDT
                  </div>
                  <div className="text">
                    <p>USDC</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                          parseFloat(
                            statsData?.stats[0]?.totalUsdc || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDC
                  </div>
                  <div className="text">
                    <p>DOP</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                          parseFloat(
                            statsData?.stats[0]?.totalDopToken || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    DOP
                  </div>
                  <div className="text">
                    <p>WBTC</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                          parseFloat(
                            statsData?.stats[0]?.totalWbtc || 0
                          )?.toFixed(6)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    WBTC
                  </div>
                  <div className="text">
                    <p>PEPE</p>
                    {statsData?.stats?.length > 0
                      ? parseInt(
                          parseFloat(
                            statsData?.stats[0]?.totalPepe || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    PEPE
                  </div>{" "}
                  <div className="text">
                    <p>LINK</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                          parseFloat(
                            statsData?.stats[0]?.totalLink || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    LINK
                  </div>{" "}
                  <div className="text">
                    <p>UNI</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                          parseFloat(
                            statsData?.stats[0]?.totalUni || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    UNI
                  </div>
                  <div className="text">
                    <p>TOMI</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                          parseFloat(
                            statsData?.stats[0]?.totalTomi || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    TOMI
                  </div>
                  <div className="text">
                    <p>GEMS</p>
                    {statsData?.stats?.length > 0
                      ? parseFloat(
                          parseFloat(
                            statsData?.stats[0]?.totalGems || 0
                          )?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    GEMS
                  </div>
                </ul>
              </div>
            </div>

            {user?.role === "admin" ? (
              <>
                <div className="single-card mobile-spec-height">
                  <div className="twice-set-items">
                    <img
                      src="\assets\dashboard\netrevenue.svg"
                      alt="img"
                      className="img-fluid"
                    />
                    <div className="inner-text">
                      <p>Project Net Revenue</p>
                      {usdPrice ? (
                        <h6 className="datahead">
                          {statsData?.stats?.length > 0
                            ? "~$" +
                              parseInt(
                                statsData?.stats[0]?.netRevenueInUsd?.toFixed(2)
                              ).toLocaleString("en-US")
                            : 0}{" "}
                          <span className={lec > 0 ? "green-text" : "red-text"}>
                            {lec ? lec.toFixed(1) + "% " : ""}
                          </span>
                        </h6>
                      ) : (
                        <h6 className="datahead">~$0.00 USD </h6>
                      )}
                    </div>
                  </div>
                  <div className="bottom-text">
                    <p className="uni-text">
                      <span></span>
                      {statsData?.stats?.length > 0
                        ? parseFloat(
                            statsData?.stats[0]?.netRevenueEth || 0
                          )?.toFixed(4)
                        : 0}{" "}
                      ETH
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {statsData?.stats?.length > 0
                        ? parseInt(
                            parseFloat(
                              statsData?.stats[0]?.netRevenueUsdt || 0
                            )?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      USDT
                    </p>
                  </div>
                  <div class="dropdown cardinsidedrop">
                    <button
                      class=""
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="7"
                        viewBox="0 0 13 7"
                        fill="none"
                      >
                        <path
                          d="M0.601562 0.5L0.601563 3.0462L6.80156 6.5L6.80156 3.9538L0.601562 0.5Z"
                          fill="#fff"
                        />
                        <path
                          d="M13 0.5L13 3.0462L6.8 6.5L6.8 3.9538L13 0.5Z"
                          fill="#fff"
                        />
                      </svg>
                    </button>
                    <ul class="dropdown-menu newmenu">
                      <div className="text">
                        <p>ETH</p>
                        {statsData?.stats?.length > 0
                          ? parseFloat(
                              statsData?.stats[0]?.netRevenueEth || 0
                            )?.toFixed(4)
                          : 0}{" "}
                        ETH
                      </div>
                      <div className="text">
                        <p>USDT</p>
                        {statsData?.stats?.length > 0
                          ? parseInt(
                              parseFloat(
                                statsData?.stats[0]?.netRevenueUsdt || 0
                              )?.toFixed(2)
                            )?.toLocaleString("en-US")
                          : 0}{" "}
                        USDT
                      </div>
                      <div className="text">
                        <p>USDC</p>
                        {statsData?.stats?.length > 0
                          ? parseInt(
                              parseFloat(
                                statsData?.stats[0]?.netRevenueUsdc || 0
                              )?.toFixed(2)
                            )?.toLocaleString("en-US")
                          : 0}{" "}
                        USDC
                      </div>
                      <div className="text">
                        <p>DOP</p>
                        {statsData?.stats?.length > 0
                          ? parseInt(
                              parseFloat(
                                statsData?.stats[0]?.netRevenueDopToken || 0
                              )?.toFixed(2)
                            )?.toLocaleString("en-US")
                          : 0}{" "}
                        DOP
                      </div>
                      <div className="text">
                        <p>WBTC</p>
                        {statsData?.stats?.length > 0
                          ? parseFloat(
                              parseFloat(
                                statsData?.stats[0]?.netRevenueWbtc || 0
                              )?.toFixed(6)
                            )
                          : 0}{" "}
                        WBTC
                      </div>
                      <div className="text">
                        <p>PEPE</p>
                        {statsData?.stats?.length > 0
                          ? parseInt(
                              parseFloat(
                                statsData?.stats[0]?.netRevenuePepe || 0
                              )?.toFixed(2)
                            )?.toLocaleString("en-US")
                          : 0}{" "}
                        PEPE
                      </div>{" "}
                      <div className="text">
                        <p>LINK</p>
                        {statsData?.stats?.length > 0
                          ? parseFloat(
                              parseFloat(
                                statsData?.stats[0]?.netRevenueLink || 0
                              )?.toFixed(2)
                            )?.toLocaleString("en-US")
                          : 0}{" "}
                        LINK
                      </div>{" "}
                      <div className="text">
                        <p>UNI</p>
                        {statsData?.stats?.length > 0
                          ? parseFloat(
                              parseFloat(
                                statsData?.stats[0]?.netRevenueUni || 0
                              )?.toFixed(2)
                            )?.toLocaleString("en-US")
                          : 0}{" "}
                        UNI
                      </div>
                      <div className="text">
                        <p>TOMI</p>
                        {statsData?.stats?.length > 0
                          ? parseFloat(
                              parseFloat(
                                statsData?.stats[0]?.netRevenueTomi || 0
                              )?.toFixed(2)
                            )?.toLocaleString("en-US")
                          : 0}{" "}
                        TOMI
                      </div>
                      <div className="text">
                        <p>GEMS</p>
                        {statsData?.stats?.length > 0
                          ? parseFloat(
                              parseFloat(
                                statsData?.stats[0]?.netRevenueGems || 0
                              )?.toFixed(2)
                            )?.toLocaleString("en-US")
                          : 0}{" "}
                        GEMS
                      </div>
                    </ul>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <img
                      src="\assets\stats\gemsnetprofit.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">Gems Net Revenue</p>
                    <h6>
                      {usdPrice ? (
                        <h6 className="datahead">
                          {statsData?.stats?.length > 0
                            ? "~$" +
                              parseInt(
                                (
                                  statsData?.stats[0]?.totalSaleConverted * 0.05
                                )?.toFixed(2)
                              ).toLocaleString("en-US")
                            : 0}{" "}
                          {profitChange >= 0 ? (
                            <span className="green-text">
                              +{parseFloat(profitChange)?.toFixed(2)}%
                            </span>
                          ) : (
                            <span className="red-text">
                              {parseFloat(profitChange)?.toFixed(2)}%
                            </span>
                          )}
                        </h6>
                      ) : (
                        <h6 className="datahead">~$0.00 USD </h6>
                      )}
                    </h6>
                  </div>
                </div>
              </div>
            </div>

            <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <img
                      src="\assets\stats\premiumleader.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">Premium Leaders</p>
                    <h6>
                      {goldenUserData?.premiumCount?.toLocaleString()}{" "}
                      {/* <span className="green">+0.8%</span> */}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {goldenUserData?.leadersStakedTokenCount?.toLocaleString()}{" "}
                  GEMS Locked
                </p>
              </div>
            </div>
            <div className="single-card">
              <div className="inner-parent">
                <div className="twice-set-items">
                  <div className="left-img">
                    <img
                      src="\assets\stats\goldenuser.svg"
                      alt="img"
                      className="img-fluid"
                    />
                  </div>
                  <div className="right-stats">
                    <p className="mt-0">Golden Users</p>
                    <h6>
                      {goldenUserData?.goldenUsers?.toLocaleString()}{" "}
                      {/* <span className="green">+0.8%</span> */}
                    </h6>
                  </div>
                </div>
              </div>
              <div className="bottom-text">
                <p className="uni-text">
                  <span></span>
                  {goldenUserData?.gemsLockedGolden?.toLocaleString()} GEMS
                  Locked
                </p>
              </div>
            </div>
          </div>

          <div className="twice-charts">
            <div className="main-graph">
              <div className="graphheading">
                <h6 className="main-heading">
                  Top 10 Countries by Number of Purchases
                </h6>
                {/* <a
                  className="seealllink"
                  onClick={() => {
                    hitfunctionss(13);
                    dispatch(chartData(statsData?.countryWisePurchases));
                  }}
                >
                  See All
                </a> */}
              </div>

              <Countrychart
                chartData={statsData?.countryWisePurchases}
                chartType={"purchases"}
                seeAll={false}
              />
            </div>
            <div className="main-graph">
              <div className="graphheading">
                <h6 className="main-heading">
                  Top 10 Countries by Purchased Amount
                </h6>
                {/* <a
                  className="seealllink"
                  onClick={() => {
                    hitfunctionss(14);
                    dispatch(chartData(statsData?.countryWiseAmount));
                  }}
                >
                  See All
                </a> */}
              </div>
              <Countrychart
                chartData={statsData?.countryWiseAmount}
                chartType={"amount"}
                seeAll={false}
              />
            </div>
          </div>

          <DataTable
            btcPrice={btcPrice}
            tomiPrice={tomiPrice}
            pepePrice={pepePrice}
            linkPrice={linkPrice}
            uniPrice={uniPrice}
            dopPrice={dopPrice}
            gemsPrice={gemsPrice}
            setSearch={setSearch}
            setTopLeaderSearch={setTopLeaderSearch}
            user={user}
            getTransactionsData={getTransactionsData}
            usdPrice={usdPrice}
            transactions={transactions}
            loader={loader}
            setOrderDirection={setOrderDirection}
            setOrderField={setOrderField}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            topTenLeaders={topTenLeaders}
            topThreeData={topThreeData}
            topTenApiCalled={topTenApiCalled}
            transactionApiCalled={transactionApiCalled}
          />
        </div>
      </section>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          {user?.role === "admin" ? (
            <Modal.Title>Add God Leader</Modal.Title>
          ) : (
            <Modal.Title>Add Leader</Modal.Title>
          )}
          {/* {user?.role === "admin" && <Modal.Title>Add Mega Agents</Modal.Title>}
                    {user?.role === "admin" && <Modal.Title>Add Mega Agents</Modal.Title>} */}
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter Leader’s Name"
                />
                {/* <label>Leader’s Name</label> */}
              </div>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="text"
                  value={addr}
                  onChange={(e) => setAddr(e.target.value)}
                  placeholder="Enter Leader’s Wallet Address"
                />
                {/* <label>Leader’s Wallet Address</label> */}
              </div>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  type="text"
                  placeholder="Enter Leader’s Email Address"
                />
                {/* <label>Leader’s Email Address</label> */}
              </div>
            </div>
            {user?.role !== "admin" && (
              <div className="option-field">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {role === null
                      ? "Type of Leader"
                      : convertToTitleCase(role)}
                  </button>
                  {user?.role === "god_agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("mega_agent")}>
                        <a class="dropdown-item" href="#">
                          Mega Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("super_agent")}>
                        <a class="dropdown-item" href="#">
                          Super Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("agent")}>
                        <a class="dropdown-item" href="#">
                          Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                  {user?.role === "mega_agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("super_agent")}>
                        <a class="dropdown-item" href="#">
                          Super Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("agent")}>
                        <a class="dropdown-item" href="#">
                          Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                  {user?.role === "super_agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("agent")}>
                        <a class="dropdown-item" href="#">
                          Leader
                        </a>
                      </li>
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                  {user?.role === "agent" && (
                    <ul class="dropdown-menu">
                      <li onClick={() => setRole("mini_agent")}>
                        <a class="dropdown-item" href="#">
                          Ambassador
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            )}
          </div>
          <p
            style={{
              color: "red",
              textAlign: "center",
              marginTop: -15,
              marginBottom: 15,
            }}
          >
            {error}
          </p>
          <div className="twice-btn">
            <button
              onClick={() => {
                handleClose1();
                setError("");
              }}
              className="btn-cancel"
            >
              Back
            </button>
            <button
              disabled={loader}
              className="btn-add"
              onClick={() => AddAgent()}
            >
              {loader ? "Adding..." : "Add"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          {user?.role === "admin" ? (
            <Modal.Title>Add Mega Leaders</Modal.Title>
          ) : (
            <Modal.Title>Add Leaders</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            {user?.role === "admin" ? (
              <h6>God Leader has been added</h6>
            ) : (
              <h6>
                {convertToTitleCase(role)}{" "}
                {convertToTitleCase(role) === "Leader"
                  ? "has been added"
                  : convertToTitleCase(role) === "Mega Leader" ||
                    convertToTitleCase(role) === "Ambassador"
                  ? "has been added"
                  : "Leader has been added"}
              </h6>
            )}
          </div>
          <div className="twice-btn">
            <button
              onClick={() => handleClose2()}
              className="btn-add"
              style={{ flex: "auto" }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Dashboard;
